
<script>
export default {
  name: "SimpleNav",
}
</script>

<template>
  <div class="container-fluid bg-white px-0 py-3">
    <div class="row justify-content-center">
      <!-- <div class="col-lg-12"> -->
        <span>
          <img src="@/assets/images/logo-store.png">
        </span>
      <!-- </div> -->
    </div>
  </div>  
</template>

<style lang="scss" scoped>
.bg-white {
  background: #fff;
}

</style>
